import { render } from "./coursewareDetail.vue?vue&type=template&id=32e3379a&scoped=true"
import script from "./coursewareDetail.vue?vue&type=script&lang=js"
export * from "./coursewareDetail.vue?vue&type=script&lang=js"

import "./coursewareDetail.vue?vue&type=style&index=0&id=32e3379a&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32e3379a"]])

export default __exports__